<template>
    <VesselsList/>
</template>
<script>
import VesselsList from '../../components/vessels/VesselsList';

export default {
  components: {
    VesselsList,
  },
};
</script>
